import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b75725"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article-read-main" }

import ArticleContent from "./Article.vue";
import { useRoute } from "vue-router";
import { nextTick, onMounted, ref, watch } from "@vue/runtime-core";
import type { Article } from "@/api/article";
import apis from "@/api/article";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const article = ref<Article>();

onMounted(() => {
  getArticle();
});

watch(
  () => route.query.articleId,
  () => {
    getArticle();
  }
);

function getArticle() {
  let articleId = Number(route.query.articleId);
  if (articleId) {
    apis.selectArticleById.request<Article>({ id: articleId }).then((res) => {
      if (res.code > 0) {
        article.value = res.data;
        document.title = res.data?.title ?? document.title;
      }
    });
  }
}

// end

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ArticleContent, {
      text: article.value?.content
    }, null, 8, ["text"])
  ]))
}
}

})